/**
 * Authentication utilities
 */

/**
 * Set auth token in localStorage and notify TenantContext to reload
 */
export function setAuthToken(token: string): void {
  localStorage.setItem('auth-token', token)
  // Reset activity timer so SessionManager doesn't immediately expire a fresh session
  localStorage.setItem('last-activity', Date.now().toString())

  // Dispatch custom event to notify TenantContext (same-window login)
  window.dispatchEvent(new Event('auth-changed'))

  console.log('[Auth] Token set and auth-changed event dispatched')
}

/**
 * Remove auth token from localStorage and notify TenantContext
 */
export function removeAuthToken(): void {
  localStorage.removeItem('auth-token')

  // Dispatch custom event to notify TenantContext (logout)
  window.dispatchEvent(new Event('auth-changed'))

  console.log('[Auth] Token removed and auth-changed event dispatched')
}

/**
 * Get auth token from localStorage
 */
export function getAuthToken(): string | null {
  return localStorage.getItem('auth-token')
}
